import { EventTypeGroup } from '../types/ViewModel/EventTypeGroup';
import { EventTypeProcessInstance } from '../types/ViewModel/EventTypeProcessInstance';
import { EventTypeProcess } from '../types/ViewModel/EventTypeProcess';
import { EventType } from '../types/ViewModel/EventType';

export class EventTypeProcessFactory {
    constructor() {}

    public createEventTypeProcess(
        eventTypeGroup: EventTypeGroup,
        eventType: EventType | null,
        sequenceNr: number | null,
        isConcurrent: boolean,
        isMandatory: boolean,
        evTypePrcInstanceList: EventTypeProcessInstance[],
        evTypePrcList: EventTypeProcess[],
        isExpandable: boolean,
        isSelectable: boolean,
        allSeqFinished: boolean,
        isExpanded: boolean,
        isSelected: boolean,
        displayName: string
    ): EventTypeProcess {
        return new EventTypeProcess(
            eventTypeGroup,
            eventType,
            sequenceNr,
            isConcurrent,
            isMandatory,
            this.createEventTypeProcessInstanceList(evTypePrcInstanceList),
            this.createEventTypeProcessList(evTypePrcList),
            isExpandable,
            isSelectable,
            allSeqFinished,
            isExpanded,
            isSelected,
            displayName
        );
    }

    public createEventTypeProcessList(evTypePrcList: EventTypeProcess[]): EventTypeProcess[] {
        if (evTypePrcList.length > 0) {
            return evTypePrcList.map((prcItem) => {
                return this.createEventTypeProcessObj(prcItem);
            });
        }
        return [];
    }

    public createEventTypeProcessObj(evTypePrc: EventTypeProcess): EventTypeProcess {
        return this.createEventTypeProcess(
            evTypePrc.eventTypeGroup,
            evTypePrc.eventType,
            evTypePrc.sequenceNr,
            evTypePrc.isConcurrent,
            evTypePrc.isMandatory,
            this.createEventTypeProcessInstanceList(evTypePrc.evTypePrcInstanceList),
            this.createEventTypeProcessList(evTypePrc.evTypePrcList),
            evTypePrc.isExpandable,
            evTypePrc.isSelectable,
            evTypePrc.allSeqFinished,
            evTypePrc.isExpanded,
            evTypePrc.isSelected,
            evTypePrc.displayName
        );
    }

    public createEventTypeProcessInstance(
        sequenceNr: number | null,
        instanceDescription: string,
        evTypePrcList: EventTypeProcess[],
        isExpanded: boolean,
        isSelected: boolean
    ): EventTypeProcessInstance {
        return new EventTypeProcessInstance(sequenceNr, instanceDescription, this.createEventTypeProcessList(evTypePrcList), isExpanded, isSelected);
    }

    public createEventTypeProcessInstanceList(evTypePrcInstList: EventTypeProcessInstance[]): EventTypeProcessInstance[] {
        if (evTypePrcInstList.length > 0) {
            return evTypePrcInstList.map((prcInstItem) => {
                return this.createEventTypeProcessInstanceObj(prcInstItem);
            });
        }
        return [];
    }

    public createEventTypeProcessInstanceObj(evTypePrcInst: EventTypeProcessInstance): EventTypeProcessInstance {
        return this.createEventTypeProcessInstance(
            evTypePrcInst.sequenceNr,
            evTypePrcInst.instanceDescription,
            evTypePrcInst.evTypePrcList,
            evTypePrcInst.isExpanded,
            evTypePrcInst.isSelected
        );
    }
}
